import Popover from "components/Popover";
import useLabels from "hooks/useLabels";

type ExcerptProps = {
  text: string;
  onSelectExcerpt: (text: string) => void;
};

function Excerpt({ text, onSelectExcerpt }: ExcerptProps) {
  const [askPaperLabels] = useLabels("ask-paper");

  return (
    <Popover
      interactive
      tooltipContent={
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-3">
            <i className="text-2xl icon-file-check-2" />
            <h3 className="sm-bold">{askPaperLabels["reference-from-pdf"]}</h3>
          </div>

          <div className="line-clamp-5">{text}</div>
        </div>
      }
    >
      <button className="ml-1" onClick={() => onSelectExcerpt(text)}>
        (
        <span className="underline text-fg-muted">
          {askPaperLabels["source"]}
        </span>
        )
      </button>
    </Popover>
  );
}

export default Excerpt;
